import { t } from "i18next";
import React, { useEffect } from "react";
import useInput from "../../../hooks/useIndicatorInput";
import IsRequiredModule from "./IsRequiredModule";

const RsiExitSetting = (props) => {
  const { indicator, updateIndicator, isLong,t } = props;
  const [exitLong, bindExitLong, setExitLong] = useInput(indicator.value3);
  const [exitShort, bindExitShort, setExitShort] = useInput(indicator.value2);
  const [periodLong, bindPeriodLong, setPeriodLong] = useInput(
    indicator.period_num,
    0
  );
  useEffect(() => {
    updateIndicator({
      ...indicator,
      value3: exitLong,
      value2: exitShort,
      period_num: periodLong,
    });
  }, [exitLong, exitShort,periodLong]);

  useEffect(() => {
    setExitLong(indicator.value3);
    setExitShort(indicator.value2);
    setPeriodLong(indicator.period_num);
  }, [indicator]);
 

  return (
    <>
    <div>
      {isLong ? (
        <>
          <h6>{t("long-strategy")}</h6>
          <div>
            <label>{t("sell-rsi-lev")}:</label>
            <input type="number" {...bindExitLong} />
          </div>
        </>
      ) : (
        <>
          <h6>{t("short-strategy")}</h6>
          <div>
            <label>{t("buy-rsi-lev")}:</label>
            <input type="number" {...bindExitShort} />
          </div>
        </>
      )}
    </div>
    <div>
        <label>{t("period")}:</label>
        <input type="number" {...bindPeriodLong} className="input-bg-color"/>
      </div>
      <IsRequiredModule indicator={indicator} updateIndicator={updateIndicator} t={t}></IsRequiredModule>
    </>
    
    
  );
};

export default RsiExitSetting;
